<template>
    <!-- DESCR：反馈页面 -->
    <div class="release-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="24" class="login-title">
                <div class="desc-box">
                    <div class="title">Contact us</div>
                    <br />
                    <div class="info">
                        You can use this page to inquire about any related website's issues
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-form ref="ruleForm" :model="contactform" label-width="260px">
                        <el-form-item prop="email" :rules="[{ required: true, message: 'email Cannot be empty' }]">
                            <template #label>
                                Your email address:
                            </template>
                            <el-input v-model="contactform.email" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="retypeEmail"
                            :rules="[{ required: true, message: 'retypeEmail Cannot be empty' }]">
                            <template #label>
                                Re-type your email address:
                            </template>
                            <el-input v-model="contactform.retypeEmail" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="name" :rules="[{ required: true, message: 'name Cannot be empty' }]">
                            <template #label>
                                Your name:
                            </template>
                            <el-input v-model="contactform.name" style="width:700px"></el-input>
                        </el-form-item>
                        <el-divider />
                        <el-form-item prop="subject" :rules="[{ required: true, message: 'subject Cannot be empty' }]">
                            <template #label>
                                Subject:
                            </template>
                            <el-input v-model="contactform.subject" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="message" :rules="[{ required: true, message: 'message Cannot be empty' }]">
                            <template #label>
                                Message:
                            </template>
                            <el-input v-model="contactform.message" type="textarea" :rows="14"
                                style="width:700px"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="submit"><el-button type="primary" @click="submit">Send Message</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import request from "../../network/request"
import { ElMessage } from 'element-plus'

//会议表单信息
const contactform = ref({
    email: "",
    retypeEmail: "",
    name: "",
    subject: "",
    message: ""

})

// 表单效验对象
const ruleForm = ref(null)

// 发布新会议
const submit = () => {
    // 效验表单信息
    ruleForm.value.validate((valid) => {
        if (valid) {
            if (contactform.value.email != contactform.value.retypeEmail) {
                ElMessage.warning({
                    message: 'two passwords do not match',
                    type: 'warning',
                })
                return
            }
            request.post("/contact", contactform.value).then((res) => {
                if (res.code == 200) {
                    ElMessage.success({
                        message: 'created successfully',
                        type: 'success',
                    })
                }
                else {
                    ElMessage.warning({
                        message: res.msg,
                        type: 'warning',
                    })
                }
            })
        } else {
            return false
        }
    })
}
</script>

<style lang="scss">
.release-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .submit {
        width: 100%;
        padding: 0;
        display: flex;
        justify-content: center;

        .el-button {
            width: 300px;
        }
    }

    .box-card {
        display: flex;
        justify-content: center;
        position: relative;
        padding: 40px 0;
        margin-bottom: 30px;
        background-color: #eef8ff2e;
    }
}
</style>